'use strict';

module.exports = inlineCode;

var toString = require('hast-util-to-string');

function inlineCode(h, node) {
  return h(node, 'inlineCode', toString(node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/inline-code.js
// module id = 1026
// module chunks = 0